import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';

const Privacy: FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-teaGreen/5 via-white to-primary-lightGreen/10">
      {/* Hero Section */}
      <section className="relative pt-20 pb-16 md:pt-24 md:pb-20 overflow-hidden">
        {/* Background Decorations */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-teaGreen/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-lightGreen/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-black mb-6 leading-tight">
              Privacy Policy
            </h1>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed">
              At AMPS DHOONDH RECRUITMENT LLP ("Dhoondh"), we respect your right to privacy and are committed to protecting your personal data.
            </p>
            <p className="text-sm text-gray-500">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="relative pb-20 md:pb-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100">
            
            {/* Information We Collect */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Information We Collect</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Account Information:</strong> Name, email, phone number, company affiliation, job seeker details.</li>
                <li><strong>Professional Information:</strong> Resume data, employment history, job preferences, salary expectations.</li>
                <li><strong>Usage Data:</strong> IP address, device details, browsing history, platform activity.</li>
                <li><strong>Marketing Data:</strong> Preferences, interaction with ads, and engagement on social media.</li>
              </ul>
            </div>

            {/* How We Use Your Information */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">How We Use Your Information</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Provide job-matching and recruitment services.</li>
                <li>Share job seeker data with employers and recruitment partners.</li>
                <li>Communicate updates, account changes, and service enhancements.</li>
                <li>Personalize recommendations and marketing campaigns.</li>
                <li>Ensure compliance with legal obligations (fraud prevention, court orders, etc.).</li>
              </ul>
            </div>

            {/* Cookies & Tracking */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Cookies & Tracking</h2>
              <p className="text-gray-700 mb-4">We use:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Essential Cookies:</strong> Required for platform functionality.</li>
                <li><strong>Analytics Cookies:</strong> Understand site traffic and performance.</li>
                <li><strong>Advertising Cookies:</strong> Deliver targeted ads.</li>
                <li>Users may manage or disable cookies in their browser, though some features may be limited.</li>
              </ul>
            </div>

            {/* Data Sharing & Disclosure */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Data Sharing & Disclosure</h2>
              <p className="text-gray-700 mb-4">Your data may be shared with:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Affiliates for training, recruitment tools, and career services.</li>
                <li>Recruitment Partners if your profile matches an opportunity.</li>
                <li>Service Providers (e.g., cloud, analytics, marketing).</li>
                <li>Legal Authorities when required.</li>
              </ul>
            </div>

            {/* Data Retention */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Data Retention</h2>
              <p className="text-gray-700 leading-relaxed">
                We retain your data only as long as necessary for service delivery or as required by law.
              </p>
            </div>

            {/* Your Rights */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Your Rights</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Access and update your personal data.</li>
                <li>Request deletion of your data.</li>
                <li>Withdraw consent for marketing communications.</li>
                <li>File complaints with Indian Data Protection Authorities.</li>
              </ul>
            </div>

            {/* Governing Law */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                This policy is governed under the Digital Personal Data Protection Bill (DPDP), India.
              </p>
            </div>

            {/* Contact Information */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-primary-black mb-4">Contact Us</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about this Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-primary-teaGreen/10 rounded-xl p-6">
                <p className="text-gray-700 mb-2">
                  <strong>Email:</strong> operations@dhoondh.in
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Phone:</strong> +91 93168 46322
                </p>
                <p className="text-gray-700">
                  <strong>Address:</strong>
                    510, Serene Centrum
                    Laxmipura, Vadodara – 390021
                </p>
              </div>
            </div>

            {/* Back to Home */}
            <div className="text-center pt-8 border-t border-gray-200">
              <Link to="/">
                <Button variant="outline" size="lg">
                  Back to Home
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
